import { Log, Tracker } from '../Tracker';
import { UBL, ZigzagEvent } from '../zigzag_app_event';
import { UBLSender } from './types';

export function convertToAppUblFromLog(log: Log): UBL {
  const { navigation_sub, data, ...restLog } = log;
  const ubl: UBL = { ...restLog };

  if (navigation_sub) {
    ubl.navigation_sub = JSON.stringify(log.navigation_sub);
  }

  if (data) {
    ubl.data = JSON.stringify(log.data);
  }

  return ubl;
}

export function createZigzagSender(tracker: Tracker): UBLSender {
  const ublSender = (log: Log) => ZigzagEvent.subl(convertToAppUblFromLog(log));
  return Object.assign(ublSender, tracker) as UBLSender;
}
